import { TabSwitch, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CardHero } from './components/CardHero';
import { HeaderSection } from './components/HeaderSection';

import { TradingDetailsTypes } from '.';

export const TradingDetailsTablet: React.FC<TradingDetailsTypes.Content> = ({
  selectedTab,
  handleTabPress,
  tabs,
  accountId,
  handleRefresh,
}) => {
  return (
    <VStack alignSelf={'center'} minHeight="fit-content" width="100%" flex={1}>
      <VStack
        px={Spacing['inline.xs']}
        borderRadius={'md'}
        shadow={1}
        flex={1}
        backgroundColor={Color['neutral.white']}>
        <HeaderSection handleRefresh={handleRefresh} title="Detalhes do cliente" />
        <CardHero accountId={accountId} />
        <Box pt={Spacing['inset.sm']}>
          <TabSwitch
            testId="tab-switch"
            tabs={tabs}
            selectedTab={selectedTab}
            onTabPress={handleTabPress}
            isLoading={false}
            isMobile={false}
          />
        </Box>
      </VStack>
    </VStack>
  );
};

TradingDetailsTablet.displayName = 'TradingDetailsTablet';
